import { render } from "./OnboardingImages.vue?vue&type=template&id=4d66f54b"
import script from "./OnboardingImages.vue?vue&type=script&lang=js"
export * from "./OnboardingImages.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2914688552/src/be-admin-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__